export * from './graphql'

import { default as introspectionResult } from './introspectionResult.json'
const { possibleTypes } = introspectionResult
export { possibleTypes }
